<template>
  <div id="wrap">
    <div id="overlay"></div>
    <!-- container -->
    <div class="container">
      <!-- top_box -->
      <div class="top_box">
        <h1>
          <img
            :src="`./images/${logo_image}`"
            alt="학교법인 신일학원 서울사이버대학교 www.iscu.ac.kr"
          />
        </h1>
        <div
          class="list"
          :class="[
            onSearch || onIndex || onAllpage || onPrintbox ? 'deactive' : '',
          ]"
        >
          <a
            href="#"
            class="bg1"
            title="검색"
            id="top_btn1"
            @click="toggleSearch()"
            >검색</a
          >
          <a
            href="#"
            class="bg2"
            title="목차"
            id="top_btn2"
            @click="toggleIndex()"
            >목차</a
          >
          <a
            href="#"
            class="bg3"
            title="전체이미지 보기"
            id="top_btn3"
            @click="toggleAllpage()"
            >전체이미지 보기</a
          >
          <!-- <a
            href="#"
            class="bg4"
            title="인쇄"
            id="top_btn4"
            @click="togglePrintbox()"
            >인쇄</a
          > -->
          <a
            href="#"
            :class="['bg5', isFullPage == true ? 'active' : '']"
            title="전체화면 보기"
            @click="fullPageToggle()"
            >전체화면 보기</a
          >
          <a href="#" class="bg6" title="창닫기" @click="closePage()">창닫기</a>
        </div>
      </div>
      <div class="util_wrapper">
        <!-- search_box 검색 -->
        <div class="right_box" id="search_box" :class="{ active: onSearch }">
          <a
            href="#"
            class="btn_close"
            title="검색 닫기"
            @click="toggleSearch()"
            >검색 닫기</a
          >
          <div class="search_top">
            <div class="search_input">
              <input
                type="text"
                v-model="search_key"
                placeholder="검색어를 입력하세요."
                @keyup.enter="doSearch()"
              />
              <a href="#" @click="doSearch()">검색</a>
            </div>
            <div class="p_result">
              <div v-if="search.key">
                <em>'{{ search.key }}'</em>에 대한 검색 결과
                <span class="em2">{{ search.result.length }}</span
                >개
              </div>
              <div v-if="!search.key">
                <em>검색어를 입력하세요.</em>
              </div>
            </div>
          </div>
          <div class="scroll_box">
            <ul class="list_search">
              <li v-for="sr in search.result" :key="sr.page">
                <a href="#" @click="pageChange(sr.page)">
                  <span class="p_page">{{ rePage(sr.page) }}페이지</span
                  ><span v-html="sr.content"></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- //search_box -->

        <!-- index_box 목차 -->
        <div class="right_box" id="index_box" :class="{ active: onIndex }">
          <a href="#" class="btn_close" title="목차 닫기" @click="toggleIndex()"
            >목차 닫기</a
          >
          <div class="scroll_box">
            <ul class="list_index">
              <li v-for="index in page_index" :key="index.key">
                <a href="#" @click="pageIndexChange(index.page, toggleIndex)">{{
                  index.title
                }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- //index_box -->

        <!-- allpage_box 전체이미지 보기 -->
        <div class="right_box" id="allpage_box" :class="{ active: onAllpage }">
          <a
            href="#"
            class="btn_close"
            title="전체이미지 닫기"
            @click="toggleAllpage()"
            >전체이미지 닫기</a
          >
          <div class="scroll_box">
            <ul class="list_page">
              <li v-for="(page, i) in page_images" :key="page.no">
                <a href="#" @click="pageChange(i + 1, toggleAllpage)"
                  ><img v-bind:src="get_thumb(page)" alt="1페이지"
                /></a>
              </li>
            </ul>
          </div>
        </div>
        <!-- //allpage_box -->

        <!-- print_box 인쇄 -->
        <!-- <div class="right_box" id="print_box" :class="{ active: onPrintbox }">
          <a
            href="#"
            class="btn_close"
            title="인쇄 닫기"
            @click="togglePrintbox()"
            >인쇄 닫기</a
          >
          <div class="print_option">
            <h2>인쇄범위</h2>
            <ul>
              <li>
                <span>
                  <input type="radio" id="curr_page" />
                  <label for="curr_page">현재페이지</label>
                </span>
                <div>
                  <select>
                    <option selected>1페이지</option>
                    <option>2페이지</option>
                    <option>3페이지</option>
                    <option>4페이지</option>
                    <option>5페이지</option>
                  </select>
                </div>
              </li>
              <li>
                <span
                  ><input type="radio" id="range_page" /><label for="range_page"
                    >범위지정</label
                  ></span
                >
                <div><input type="text" /> - <input type="text" /></div>
              </li>
              <li>
                <span
                  ><input type="radio" id="all_page" /><label for="all_page"
                    >전체페이지</label
                  ></span
                >
              </li>
            </ul>
            <a href="#" class="btn_print">인쇄하기</a>
          </div>
          <div class="scroll_box"></div>
        </div> -->
        <!-- //print_box -->
      </div>
      <!-- //top_box -->
      <!-- content_box -->
      <div class="content_box">
        <div
          class="dragarea"
          :class="{ active: page_zoom !== 1 }"
          @mousedown="page_dragstart"
          @mouseup="page_dragend"
          @mousemove="page_drag"
          @touchstart="page_touchstart"
          @touchmove="page_touchdrag"
        ></div>
        <div class="page_wrapper">
          <div class="page_mover">
            <div class="page_box">
              <div
                class="page_item"
                v-for="page in page_images"
                :key="page.no"
                :style="[
                  zoomRaito == 100
                    ? {
                        'background-image':
                          'url(./contents/pages/' + page + ')',
                      }
                    : {
                        'background-image':
                          'url(./contents/pages_original/' + page + ')',
                      },
                ]"
              >
                <!-- <img :src="`/contents/pages_thumb/${page.image}`" /> -->
                <!-- <img :src="`./contents/pages/${page.image}`" /> -->
                <div></div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn_page">
          <a
            href="#"
            class="btn_prev_page"
            title="이전페이지로 이동"
            @click="pagePrev()"
            >이전페이지로 이동</a
          >
          <a
            href="#"
            class="btn_next_page"
            title="다음페이지로 이동"
            @click="pageNext()"
            >다음페이지로 이동</a
          >
        </div>

        <div class="zoom_box">
          <a href="#" class="btn_plus" @click="pageZoomUp()">확대</a>
          <div class="vertical-slider-wrapper">
            <input
              class="vertical-slider"
              orient="vertical"
              type="range"
              min="50"
              max="300"
              @change="pageZoomSlider($event)"
              @mousemove="pageZoomSlider($event)"
              @touchstart="pageZoomSlider($event)"
              @touchmove="pageZoomSlider($event)"
              v-model="page_zoomx"
            />
          </div>
          <a href="#" class="btn_minus" @click="pageZoomDown()">축소</a>
          <div class="curr">
            <a @click="pageZoomDefault()">
              <span>{{ zoomRaito }}</span
              >%
            </a>
          </div>
        </div>
      </div>
      <!-- //content_box -->
      <!-- bottom_box -->
      <div class="bottom_box">
        <div class="control_box">
          <div class="page_num">
            <input
              type="text"
              class="curr"
              :value="reNowPage"
              @keyup.enter="ePageChange"
            />
            <div class="total">{{ page_images.length - start + 1 }}</div>
          </div>
          <a href="#" class="bg1" title="처음으로 이동" @click="pageFirst()"
            >처음으로 이동</a
          >
          <a href="#" class="bg2" title="이전으로 이동" @click="pagePrev()"
            >이전으로 이동</a
          >
          <a href="#" class="bg3" title="다음으로 이동" @click="pageNext()"
            >다음으로 이동</a
          >
          <a href="#" class="bg4" title="마지막으로 이동" @click="pageLast()"
            >마지막으로 이동</a
          >
        </div>
        <a :href="'contents/' + origin_file" download class="btn_pdf"
          >PDF 다운로드</a
        >
      </div>
      <!-- //bottom_box -->
    </div>
    <!-- //container -->
  </div>
</template>


<script>
import $ from "jquery";
import "@ksedline/turnjs";
import search_texts from "../assets/search.json";
import data_pages from "../assets/pages.json";
import data_index from "../assets/index.json";

export default {
  name: "Ebook",
  components: {},
  data() {
    return {
      start: 0,
      display: "double",
      logo_image: "",
      onSearch: false,
      onIndex: false,
      onAllpage: false,
      onPrintbox: false,

      page_now: 1,
      page_zoom: 1,
      page_zoomx: 100,

      origin_file: "",
      page_images: [],
      page_index: [],
      origin_sizes: {},

      search_key: "",
      search: {
        key: "",
        result: [],
      },

      pageconf: {},

      drag: {
        stats: false,
        startX: 0,
        startY: 0,
        x: 0,
        y: 0,
        containerX: 0,
        containerY: 0,
      },

      isFullPage: false,
    };
  },
  computed: {
    zoomRaito: function () {
      return Math.floor(this.page_zoom * 100);
    },
    reNowPage: function () {
      let tmp_repage = this.page_now - this.start + 1;
      // console.log(tmp_repage);
      if (tmp_repage <= 0) tmp_repage = "-";
      return tmp_repage;
    },
  },
  methods: {
    rePage: function (page) {
      let tmp_page = page - this.start + 1;
      if (tmp_page <= 0) tmp_page = "-";
      return tmp_page;
    },
    get_thumb: function (pageno) {
      return "./contents/pages_thumb/" + pageno;
    },
    toggleSearch: function () {
      this.onSearch = this.onSearch ? false : true;
    },
    toggleIndex: function () {
      this.onIndex = this.onIndex ? false : true;
    },
    toggleAllpage: function () {
      this.onAllpage = this.onAllpage ? false : true;
    },
    togglePrintbox: function () {
      this.onPrintbox = this.onPrintbox ? false : true;
    },
    pageNext: function () {
      $(".page_box").turn("disable", false);
      this.page_now =
        this.page_now + this.pageconf.pagecount > this.page_images.length
          ? this.page_images.length
          : this.page_now + this.pageconf.pagecount;

      $(".page_box").turn("page", this.page_now);
      this.switchDisable();
    },
    pagePrev: function () {
      $(".page_box").turn("disable", false);
      this.page_now =
        this.page_now - this.pageconf.pagecount < 1
          ? 1
          : this.page_now - this.pageconf.pagecount;
      $(".page_box").turn("page", this.page_now);
      this.switchDisable();
    },
    pageFirst: function () {
      $(".page_box").turn("disable", false);
      this.page_now = 1;
      $(".page_box").turn("page", this.page_now);
      this.switchDisable();
    },
    pageLast: function () {
      $(".page_box").turn("disable", false);
      this.page_now = this.page_images.length;
      $(".page_box").turn("page", this.page_now);
      this.switchDisable();
    },
    ePageChange: function () {
      $(".page_box").turn("disable", false);
      // this.pageChange(Number(event.target.value) + this.start);
      $(".page_box").turn("page", Number(event.target.value) + this.start - 1);
      this.switchDisable();
    },
    pageIndexChange: function (page, cb) {
      page = Number(page) + Number(this.start) - 1;
      this.pageChange(page, cb);
    },
    pageChange: function (page, cb) {
      $(".page_box").turn("disable", false);
      this.page_now = page;
      $(".page_box").turn("page", Number(page));
      this.switchDisable();

      if (typeof cb === "function") {
        cb();
      }
    },
    pageZoomDefault: function () {
      this.page_zoom = 1;
      this.page_zoomx = this.page_zoom * 100;
      this.pageZoom();
    },
    pageZoomUp: function () {
      this.page_zoom = this.page_zoom + 0.25;
      if (this.page_zoom > 3) this.page_zoom = 3;
      this.page_zoomx = this.page_zoom * 100;
      this.pageZoom();
    },
    pageZoomDown: function () {
      this.page_zoom = this.page_zoom - 0.25;
      if (this.page_zoom < 0.5) this.page_zoom = 0.5;
      this.page_zoomx = this.page_zoom * 100;
      this.pageZoom();
    },
    pageZoomSlider: function (event) {
      this.page_zoom = event.target.value / 100;
      this.page_zoomx = this.page_zoom * 100;
      this.pageZoom();
    },
    pageZoom: function () {
      $(".page_box").css("transform", `scale(${this.page_zoom})`);
      this.switchDisable();
    },
    switchDisable: function () {
      if (this.page_zoom == 1) {
        $(".page_mover").css("top", 0);
        $(".page_mover").css("left", 0);
        $(".page_box").turn("disable", false);
      } else {
        $(".page_box").turn("disable", true);
      }
    },
    fullPageToggle: function () {
      const documentElement = document.documentElement;
      if (document.fullscreenElement === null) {
        documentElement.requestFullscreen();
        this.isFullPage = true;
      } else {
        document.exitFullscreen();
        this.isFullPage = false;
      }
    },
    closePage: function () {
      window.close();
    },
    doSearch: function () {
      this.search.key = this.search_key;
      let results = [];

      search_texts.forEach((texts) => {
        if (texts.strs.search(this.search.key) !== -1) {
          let startpos =
            texts.strs.search(this.search.key) - 10 > 0
              ? texts.strs.search(this.search.key) - 10
              : 0;
          let endpos = texts.strs.search(this.search.key) + 30;
          results.push({
            page: texts.page,
            content: texts.strs
              .substr(startpos, endpos)
              .replace(this.search.key, `<em>${this.search.key}</em>`),
          });
        }
      });

      this.search.result = results;
    },

    calc_booksize: function () {
      let ow = data_pages.sizes.ow;
      let oh = data_pages.sizes.oh;
      let nh = $(".content_box").height();
      let nw = ((ow * nh) / oh) * 2;
      let display = "single";
      let pagecount = 1;

      if ($(window).width() < 1080) {
        nw = $(".content_box").width() - 0;
        nh = (oh * nw) / ow;

        if (nh > $(window).height() - 140) {
          nh = $(window).height() - 140;
          nw = (ow * nh) / oh;
        }

        display = "single";
        pagecount = 1;

        if ($(window).width() > $(window).height() * 1.6) {
          display = "double";
          pagecount = 2;
          nw = nw * 2;
        }
      } else {
        display = "double";
        pagecount = 2;
      }

      if (this.display == "single") {
        display = "single";
        pagecount = 1;
      }

      this.pageconf = {
        nh: nh,
        nw: nw,
        display: display,
        pagecount: pagecount,
      };
    },
    init_book: function () {
      let pageChange = this.pageChange;

      $(".page_box").css("top", "-" + this.pageconf.nh / 2 + "px");
      $(".page_box").css("left", "-" + this.pageconf.nw / 2 + "px");

      $(".page_box").turn({
        width: this.pageconf.nw,
        height: this.pageconf.nh,
        autoCenter: true,
        gradients: true,
        when: {
          turned: function (e, p, v) {
            e, v;
            pageChange(Number(p));
          },
        },
      });
      $(".page_box").turn("display", this.pageconf.display);

      $(document).keydown((e) => {
        var previous = 37,
          next = 39;

        switch (e.keyCode) {
          case previous:
            // $(".page_box").turn("previous");
            this.pagePrev();
            break;
          case next:
            // $(".page_box").turn("next");
            this.pageNext();
            break;
        }
      });
    },
    resize_book: function () {
      this.calc_booksize();

      $(".page_box").turn("display", this.pageconf.display);
      $(".page_box").css("top", "-" + this.pageconf.nh / 2 + "px");
      $(".page_box").css("left", "-" + this.pageconf.nw / 2 + "px");

      $(".page_box").turn("size", this.pageconf.nw, this.pageconf.nh);
      $(".page_box").turn("resize");
    },

    page_dragstart: function (e) {
      this.drag.stats = true;
      this.drag.startX = e.x;
      this.drag.startY = e.y;

      this.page_zoom;
      this.drag.containerX = $(".page_mover").position().left;
      this.drag.containerY = $(".page_mover").position().top;
    },
    page_dragend: function (e) {
      this.drag.stats = false;
      e;
    },
    page_drag: function (e) {
      if (this.drag.stats == true) {
        this.drag.x = Number(e.x) - Number(this.drag.startX);
        this.drag.y = Number(e.y) - Number(this.drag.startY);
        $(".page_mover").css(
          "top",
          Number(this.drag.containerY) + Number(this.drag.y) + "px"
        );
        $(".page_mover").css(
          "left",
          Number(this.drag.containerX) + Number(this.drag.x) + "px"
        );
      }
    },

    page_touchstart: function (e) {
      this.drag.stats = true;
      this.drag.startX = e.touches[0].clientX;
      this.drag.startY = e.touches[0].clientY;

      this.page_zoom;
      this.drag.containerX = $(".page_mover").position().left;
      this.drag.containerY = $(".page_mover").position().top;
    },
    page_touchdrag: function (e) {
      if (this.drag.stats == true) {
        this.drag.x = Number(e.touches[0].clientX) - Number(this.drag.startX);
        this.drag.y = Number(e.touches[0].clientY) - Number(this.drag.startY);
        $(".page_mover").css(
          "top",
          Number(this.drag.containerY) + Number(this.drag.y) + "px"
        );
        $(".page_mover").css(
          "left",
          Number(this.drag.containerX) + Number(this.drag.x) + "px"
        );
      }
    },
  },
  beforeUnmount: function () {},
  mounted: function () {
    this.display = data_pages.display ? data_pages.display : "double";
    this.calc_booksize();
    this.page_images = data_pages.pages;
    this.page_index = data_index.index;
    this.origin_file = data_pages.file;
    this.start = data_pages.start ? Number(data_pages.start) : 1;
    // console.log(data_pages.display)

    // document.title = data_pages.title;
    this.logo_image = data_pages.logo;

    $(window).resize(() => {
      if ($(".page_box").turn("is")) {
        this.resize_book();
      }
    });
    $(document).ready(() => {
      this.init_book();
    });
  },
};
</script>
